module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('HTMLHeader'), _vm._v(" "), _c('section', {
    staticClass: "errorpage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.status === 404) ? _c('div', [_c('h1', [_vm._v("Hiba 404")]), _vm._v(" "), _c('h3', [_vm._v("A keresett fájl nem létezik.")])]) : _vm._e(), _vm._v(" "), (_vm.status === 401) ? _c('div', [_c('h1', [_vm._v("Hiba 401")]), _vm._v(" "), _c('h3', [_vm._v("A fájl megtekintéséhez be kell jelentkezni.")])]) : _vm._e(), _vm._v(" "), (_vm.status === 403) ? _c('div', [_c('h1', [_vm._v("Hiba 403")]), _vm._v(" "), _c('h3', [_vm._v("A fájl megtekintéséhez nincs jogosultsága.")])]) : _vm._e()])])])]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bccfaa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/uploads.vue
// module id = 323
// module chunks = 0